export default __webpack_public_path__ + "static/media/offer-icon.94b58ec3.png";